import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logo from "../../Assets/IconSVG/SolidarityLogo.svg";
import OneAppIcon from "../../Assets/IconSVG/one_app_alsalam_marketplace.svg";
import appleLogo from "../../Assets/Images/apple.svg";
import googleLogo from "../../Assets/Images/google.svg";

const OneAppError = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  const handleGoBack = () => {
    // Navigate back to the payment page with the same ID
    navigate(`/payment?id=${id}`);
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-50">
      <div className="p-12 w-[48%] mt-[7%] mx-auto bg-white rounded-[26px] max767:pt-8 max767:mt-0 max767:p-5 max767:w-[100%] max767:rounded-none ipad:w-[95%] ipad:mt-[14%]">
        {/* Header with logos */}
        <div className="flex justify-center items-center gap-4 mb-8">
          <img src={logo} alt="Solidarity Logo" className="h-12" />
          <div className="h-10 w-px bg-gray-300"></div>
          <img src={OneAppIcon} alt="One App Logo" className="h-12" />
        </div>

        {/* Error Message */}
        <div className="mb-8 p-6 bg-red-50 rounded-lg border border-red-200">
          <div className="flex items-start gap-3 mb-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-red-500 flex items-center justify-center">
              <svg
                className="w-4 h-4 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <div>
              <h2 className="text-red-700 text-xl font-semibold mb-2">
                Something went wrong
              </h2>
              <p className="text-gray-700 text-base leading-relaxed">
                Something went wrong while processing your One App payment.
                <br />
                This may happen if you don't have a One App account or due to a
                temporary issue. Please try again or choose a different payment
                method.
              </p>
            </div>
          </div>
        </div>

        {/* Go Back Button */}
        <div className="mb-8 flex justify-center">
          <button
            onClick={handleGoBack}
            className="px-6 py-3 bg-white border-2 border-gray-300 text-gray-800 font-semibold rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 shadow-sm"
          >
            Go Back and Try Again
          </button>
        </div>

        {/* Download Section */}
        <div className="mb-6">
          <h3 className="text-sm font-semibold text-gray-800 mb-3 uppercase tracking-wide">
            DOWNLOAD ONE APP
          </h3>
          <div className="flex gap-3 flex-wrap">
            <a
              href="https://apps.apple.com/bh/app/one-marketplace/id6737277998"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <img
                src={appleLogo}
                alt="Download on the App Store"
                className="h-12 cursor-pointer hover:opacity-80 transition-opacity"
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=bh.one.app&hl=en"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block"
            >
              <img
                src={googleLogo}
                alt="Get it on Google Play"
                className="h-12 cursor-pointer hover:opacity-80 transition-opacity"
              />
            </a>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-gray-500 text-xs leading-relaxed mb-1">
            Solidarity Bahrain is a Subsidiary of Solidarity Group Holding
          </p>
          <p className="text-gray-500 text-xs leading-relaxed">
            Licensed and regulated by the Central Bank of Bahrain as a locally
            incorporated Takaful Firm – Category four
          </p>
        </footer>
      </div>
    </div>
  );
};

export default OneAppError;
